import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {joinMeetingSlice, setMeetingURL} from "../../../../slice/groups/botton-lesson/joinMeetingSlice";



export const startMeeting = createAsyncThunk(
    "lessons/startMeeting",
    async (lessonsId: number | string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get(`/api/lessons/${lessonsId}/start-meeting`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(setMeetingURL(response.data.url));
                return response.data;
            } else {
                console.error("Ошибка при выполнении joinMeeting:", response.data.error);
                return thunkAPI.rejectWithValue(response.data.error);
            }
        } catch (error) {
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
